let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("6aY84"), load("7e0wS")]).then(() => parcelRequire('lbcRX'));